import { useLocalCSSRule } from '../../../../../_helpers/hooks/useLocalCSSRule.tsx';
import { isSsr } from '../../../../../_helpers/isSsr.tsx';

export const ArticleHeaderImage: React.FC<{
	imagePath: string;
	imageAlt: string;
	imageVerticalPosition: string;
	isIsharesVariant: boolean;
}> = ({ imageAlt, imageVerticalPosition, imagePath, isIsharesVariant }) => {
	const id = isSsr()
		? ''
		: useLocalCSSRule({
				objectPosition: '50% ' + +(imageVerticalPosition ?? 50) + '%',
			});
	return (
		<div className="image-container">
			{imagePath && (
				<img
					id={id}
					src={imagePath}
					alt={imageAlt || ''}
					data-final-url
					className={isIsharesVariant ? 'ishares' : ''}
				/>
			)}
		</div>
	);
};
